<template>
    <div class="regular-filters">
        <regular-filter v-for="filterData in regularFiltersData"
            :key="getFilterKey(filterData)"
            v-bind="filterData"
            @change="handleFilterChange($event, filterData.type)" />
    </div>
</template>

<script>
import RegularFilter from './RegularFilter.vue';
import _ from 'lodash';
const REGULAR_FILTER_CONFIG = [
    {
        type: 'section',
        searchPlaceholder: 'Search sections',
        listTitle: 'Include the following sections:'
    },
    {
        type: 'attribute',
        searchPlaceholder: 'Search attributes',
        listTitle: 'Include the following attributes:'
    },
    {
        type: 'urlAttribute',
        searchPlaceholder: 'Search url attributes',
        listTitle: 'Include the following url attributes:'
    },
    {
        type: 'pageType',
        searchPlaceholder: 'Search page types',
        listTitle: 'Include the following page types:'
    },
    {
        type: 'urlStatus',
        searchPlaceholder: 'Search url statuses',
        listTitle: 'Include the following url statuses:'
    },
]

export default {
    name: 'RegularFilters',
    emits: ['change'],
    components: { RegularFilter },
    props: {
        options: {
            type: Array,
            default: []
        },
        selectedOptions: {
            type: Array,
            default: []
        },
        regularFilterConfig: {
            type: Array,
            default: () => REGULAR_FILTER_CONFIG
        }
    },
    data() {
        return {
            currentOptions: [],
            regularFiltersData: [],
        }
    },
    created() {
        this.setFiltersData();
    },
    watch: {
        selectedOptions: {
            handler() {
                this.setFiltersData();
            },
            deep: true
        },
        options() {
            this.setFiltersData();
        }
    },
    methods: {
        setFiltersData() {
            const rawOptionGroups = {};
            this.regularFilterConfig.forEach(config => rawOptionGroups[config.type] = { values: [], ...config });

            this.selectedOptions.forEach(option => {
                if (option.selectedOperator === 'equal') {
                    rawOptionGroups[option.type].values.push(option.selectedFilter.value);
                }
            });

            this.regularFiltersData = Object.values(rawOptionGroups);
            this.regularFiltersData.forEach(filterData => {
                const targetOption = this.options.find(option => option.type === filterData.type && option.selectedOperator === 'equal');
                filterData.label = targetOption?.label || '';
                filterData.options = targetOption?.operators.options || [];
            });
        },
        getFilterKey(filterData) {
            let key = filterData.type + filterData.id;
            key += filterData.values.join('-');

            return key;
        },
        updateOptions(options) {
            options.forEach((option, index) => {
                const selectedOption = this.selectedOptions.find(selectedOption => {
                    return option.type === selectedOption.type &&
                        selectedOption.selectedOperator === 'equal' &&
                        !!selectedOption.selectedFilter;
                });

                if (selectedOption) {
                    options[index] = { ...selectedOption };
                }
            })
        },
        handleFilterChange(values, type) {
            const selectedOptionsToKeep = this.selectedOptions.filter(option => {
                return option.type !== type || option.selectedOperator !== 'equal';
            });
            const targetRawOption = this.options.find(option => option.type === type);
            const changedOptions = values.map((selectedFilter, index) => ({
                ...targetRawOption,
                // add index to avoid id duplication
                id: Date.now().valueOf() + index,
                selectedField: type,
                selectedOperator: 'equal',
                selectedFilter
            }));
            this.$emit('change', [...selectedOptionsToKeep, ...changedOptions]);
        }
    }
}
</script>

<style scoped
    lang="scss">
    .regular-filters {
        display: flex;
        gap: 8px;
        align-items: center;
    }
</style>